import PropTypes from 'prop-types'
import React from 'react'
import { Helmet } from 'react-helmet'
import { isTestBuild } from '../../helpers/environment'
import { createLinks, createMetadata } from '../../helpers/head'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const HeadTags = ({
  pagePath,
  title,
  description,
  imageUrl,
  shouldIndex,
  canonical,
}) => {
  // Don't add the script if we are in test
  const recaptchaScript = isTestBuild()
    ? []
    : [
        <script
          src="https://www.google.com/recaptcha/api.js?render=explicit"
          key="script-recaptcha"
        />,
      ]

  const metadata = createMetadata({
    title,
    description,
    imageUrl,
    pagePath,
    shouldIndex,
  })

  const links = createLinks({
    canonical,
    pagePath,
  })

  return [
    <Helmet title={title} meta={metadata} link={links} key="helmet">
      <meta charset="utf-8" key="metaCharset" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
        key="metaViewport"
      />
      {recaptchaScript}
    </Helmet>,
  ]
}

HeadTags.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  imageUrl: PropTypes.string.isRequired,
  pagePath: PropTypes.string.isRequired,
  shouldIndex: PropTypes.bool,
  canonical: PropTypes.string,
}

HeadTags.defaultProps = {
  shouldIndex: true,
  canonical: null,
  description: null,
}

export default HeadTags
